import React from 'react';
import { DEFAULT_THEME } from '@constants/constants';
import { RountingIndicator } from '@/components/RountingIndicator';
import { Dots } from '@/components/ActivityIndicator/Dots';

interface ILayoutProps {
  children?: React.ReactNode;
  theme?: AppTheme;
}

export const RootLayout = ({ children, theme = DEFAULT_THEME }: ILayoutProps) => {
  return (
    <div data-theme={theme}>
      <Dots />
      <RountingIndicator />
      {children}
    </div>
  );
};
